import Cookies from 'js-cookie';
import { uid } from 'uid/secure';
var TokenKey = 'Admin-Token';
export function getToken() {
  return Cookies.get(TokenKey);
}
export function setToken(token) {
  return Cookies.set(TokenKey, token, {
    expires: 1500 / (24 * 60 * 60)
  });
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function getDeviceId() {
  var deviceId = localStorage.getItem('deviceId');
  if (!deviceId) {
    deviceId = uid(32);
    localStorage.setItem('deviceId', deviceId);
  }
  return deviceId;
}
export function setUserIdCookie(userId) {
  var cookieValue = "UserId=".concat(userId, "; path=/");
  document.cookie = cookieValue;
  return cookieValue;
}
export function removeUserIdCookie() {
  return document.cookie = 'UserId=; path=/';
}